import { getEmailPattern } from '@/components/utils/globalFunction'
import i18n from '@/i18n/config.js'

const { t } = i18n.global

class Validator {
  static confirmPasswordRule(confirmPassword) {
    return [(value) => value === confirmPassword || t('ERROR_INPUT.PASSWORD.DIFFERENT_PASSWORD')]
  }

  static filesMaximumCountRule(currentLength, maxLength) {
    return [
      (value) =>
        !value ||
        value.length <= maxLength - currentLength ||
        t('ERROR_INPUT.MAX_FILES', {
          max: maxLength - currentLength
        })
    ]
  }

  static requiredRules = [(value) => !!value || t('ERROR_INPUT.EMPTY')]

  static trimmedRequiredRules = [
    (value) => (value && value.trim() !== '') || t('ERROR_INPUT.EMPTY')
  ]

  static requiredMultipleRules = [(value) => value.length > 0 || t('ERROR_INPUT.EMPTY')]

  static isBooleanRules = [(value) => typeof value === 'boolean' || t('ERROR_INPUT.EMPTY')]

  static emailRules = [(value) => getEmailPattern().test(value) || t('ERROR_INPUT.EMAIL.INVALID')]

  static passwordRules = [
    (value) => !!value || t('ERROR_INPUT.PASSWORD.EMPTY'),
    (value) => value.length >= 12 || t('ERROR_INPUT.PASSWORD.ERROR_LENGTH'),
    (value) => Validator._containsUppercase(value) || t('ERROR_INPUT.PASSWORD.ERROR_UPPERCASE'),
    (value) => Validator._containsLowercase(value) || t('ERROR_INPUT.PASSWORD.ERROR_LOWERCASE'),
    (value) => Validator._containsDigit(value) || t('ERROR_INPUT.PASSWORD.ERROR_DIGIT'),
    (value) => Validator._containsSpecialChar(value) || t('ERROR_INPUT.PASSWORD.ERROR_SPECIAL_CHAR')
  ]

  static numberRules = [
    (value) =>
      value !== '' ||
      (value !== null && value.length > 0) ||
      !isNaN(value) ||
      t('ERROR_INPUT.NOT_A_NUMBER'),
    (value) => value >= 0 || t('ERROR_INPUT.POSITIVE_VALUE')
  ]

  static marginRules = [
    (value) => !isNaN(parseFloat(value)) || t('ERROR_INPUT.NOT_A_NUMBER'),
    (value) => value >= 0 || t('ERROR_INPUT.POSITIVE_VALUE'),
    (value) => value <= 60 || t('ERROR_INPUT.MARGIN_MAX_VALUE')
  ]

  static max11CharRules = [(value) => !value || value.length <= 11 || t('ERROR_INPUT.MAX_LENGTH')]

  static max12CharRules = [(value) => !value || value.length <= 12 || t('ERROR_INPUT.MAX_LENGTH')]

  static max50CharRules = [(value) => !value || value.length <= 50 || t('ERROR_INPUT.MAX_LENGTH')]

  static max100CharRules = [(value) => !value || value.length <= 100 || t('ERROR_INPUT.MAX_LENGTH')]

  static max150CharRules = [(value) => !value || value.length <= 150 || t('ERROR_INPUT.MAX_LENGTH')]

  static max255CharRules = [(value) => !value || value.length <= 255 || t('ERROR_INPUT.MAX_LENGTH')]

  static isNumberRules = [(value) => !isNaN(parseFloat(value)) || t('ERROR_INPUT.NOT_A_NUMBER')]

  static positiveNumberRules = [(value) => value >= 0 || t('ERROR_INPUT.POSITIVE_VALUE')]

  static _containsUppercase(password) {
    return /[A-Z]/.test(password)
  }

  static _containsLowercase(password) {
    return /[a-z]/.test(password)
  }

  static _containsDigit(password) {
    return /[0-9]/.test(password)
  }

  static _containsSpecialChar(password) {
    return /[!@#$%^&*(),.?":{}|<>]/.test(password)
  }
}

export default Validator
